import React from 'react';
import ResumeSide from './../../components/resumeSide/ResumeSide';

const Resume = () => (
    <>
        <ResumeSide />
    </>
);

export default Resume;